
export function formatTime (time,type) {
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];
  let unixtime = time;
  let unixTimestamp = new Date(unixtime);
  let Y = unixTimestamp.getFullYear();
  let M2 = (unixTimestamp.getMonth() >= 9 ? (unixTimestamp.getMonth()+1) : '0'+ (unixTimestamp.getMonth()+1));
  let M = monthNames[unixTimestamp.getMonth()];
  let D = (unixTimestamp.getDate() >= 10 ? unixTimestamp.getDate():'0'+unixTimestamp.getDate());
  let H = (unixTimestamp.getHours()< 10 ? '0'+ unixTimestamp.getHours() : unixTimestamp.getHours());
  let F = (unixTimestamp.getMinutes() <= 10 ? '0'+ unixTimestamp.getMinutes() : unixTimestamp.getMinutes());
  let S = (unixTimestamp.getSeconds() <= 10 ? '0'+ unixTimestamp.getSeconds() : unixTimestamp.getSeconds());
  let toDay2 = Y+ '/ '+ M2+' /'+D;
  let toDay = M + ' ' + D+ ','+ Y;
  let toHour = H+':'+F+':'+S;
  if (type === 1){
    return toDay
  } else if (type === 0){
    return toHour
  } else if (type === 2) {
    return toDay2
  }
}

export function stringFormat() {
  if (arguments.length === 0)
    return null;
  let str = arguments[0];
  for (let i = 1; i < arguments.length; i++) {
    let re = new RegExp('\\{' + (i - 1) + '\\}', 'gm');
    str = str.replace(re, arguments[i]);
  }
  return str;
}



// WEBPACK FOOTER //
// ./src/util/index.js